import { createStore } from 'vuex'
import axiosClient from '@/axios'
import type Order from '@/types/Order'

export const store = createStore({
  state: {
    user: {
      data: {},
      userId: sessionStorage.getItem('USER_ID'),
      token: sessionStorage.getItem('TOKEN'),
    },
    currentOrder: {} as Order
  },
  getters: {},
  actions: {
    loginUser({ commit }, user) {
      return axiosClient.post('/admins/login', user).then(({ data }) => {
        commit('setUser', data)
        return data
      })
    },
    logoutUser({ commit }) {
      return axiosClient.get('/admins/logout').then(response => {
        commit('logoutUser')
        return response
      })
    },
  },
  mutations: {
    logoutUser: state => {
      state.user.token = null
      state.user.userId = null
      state.user.data = {}
      sessionStorage.removeItem('USER_ID')
      sessionStorage.removeItem('TOKEN')
    },
    setUser: (state, userData) => {
      // userData from res from action
      state.user.token = userData.token
      state.user.userId = userData.id
      state.user.data = userData.user
      sessionStorage.setItem('TOKEN', userData.token)
      sessionStorage.setItem('USER_ID', userData.id)
    },
  },
  modules: {},
})

export default store
